import { Quill } from "../patches/PatchedQuill";
export const supportedFormats = ['bold', 'italic', 'link', 'strike', 'underline', 'header', 'indent', 'list'];

/** Rich text is always saved as a stringified object. This is the object interface once parsed. */

export function extractQuillDelta(maybeRichText) {
  try {
    const parsed = JSON.parse(maybeRichText);
    if (parsed.type === 'quill-delta' && 'value' in parsed) {
      return parsed;
    }
    return null;
  } catch (error) {
    return null;
  }
}
export function isEmptyRichText(richText) {
  return richText.value.ops.length === 0 || richText.value.ops.length === 1 && richText.value.ops[0].insert.replaceAll('\\n', '').replaceAll('\n', '') === '';
}
export function convertStrToRichText(maybeHTML) {
  const isHTML = maybeHTML.match(/(<([^>]+)>)/gi) != null;
  if (!isHTML) {
    return maybeHTML;
  } else {
    const containerEl = document.createElement('div');
    containerEl.style.height = '0';
    containerEl.style.visibility = 'hidden';
    document.body.appendChild(containerEl);
    const quill = new Quill(containerEl, {
      formats: supportedFormats
    });
    quill.clipboard.dangerouslyPasteHTML(maybeHTML);
    const pastedDelta = quill.getContents();
    document.body.removeChild(containerEl);
    const richTextString = JSON.stringify(makeParsedRichText(pastedDelta));
    return richTextString.replace(/<([^>]+)>/g, '&lt;$1&gt;');
  }
}
export function makeParsedRichText(value) {
  return {
    type: 'quill-delta',
    value
  };
}